import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/language/LanguageContext';
import './Gallery.css';

const Gallery = () => {
    const { language } = useLanguage();
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        const fetchGallery = async () => {
            try {
                const response = await fetch('https://admins.mahaviharahlegu.org/api/gallery.php', {
                    method: 'GET',
                    mode: 'cors',
                    credentials: 'omit',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    referrer: 'https://www.mahaviharahlegu.org/',
                    referrerPolicy: 'strict-origin-when-cross-origin'
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch gallery images');
                }

                const data = await response.json();
                if (data.success) {
                    setImages(data.data);
                } else {
                    throw new Error(data.error || 'Failed to fetch gallery images');
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchGallery();
    }, []);

    const handleImageClick = (image) => {
        setSelectedImage(image);
    };

    const closeLightbox = () => {
        setSelectedImage(null);
    };

    if (loading) {
        return (
            <div className="gallery-container">
                <div className="loading-spinner">Loading...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="gallery-container">
                <div className="error-message">{error}</div>
            </div>
        );
    }

    return (
        <div className="gallery-container">
            <div className="gallery-header">
                <h1>{language === 'en' ? 'Photo Gallery' : 'ဓာတ်ပုံများ'}</h1>
                <p>{language === 'en' ? 'Explore our collection of memorable moments' : 'ကျွန်ုပ်တို့၏ မှတ်မိဖွယ်ကောင်းသော အချိန်များကို ကြည့်ရှုရန်'}</p>
            </div>

            <div className="gallery-grid">
                {images.map((image) => (
                    <div key={image.id} className="gallery-item" onClick={() => handleImageClick(image)}>
                        <img
                            src={`https://admins.mahaviharahlegu.org/${image.image_path}`}
                            alt={image.title}
                            className="gallery-image"
                            loading="lazy"
                        />
                        <div className="gallery-item-info">
                            <h3>{image.title}</h3>
                            <p className="category">{image.category}</p>
                            <p className="date">{new Date(image.created_at).toLocaleDateString()}</p>
                        </div>
                    </div>
                ))}
            </div>

            {selectedImage && (
                <div className="lightbox" onClick={closeLightbox}>
                    <div className="lightbox-content">
                        <img
                            src={`https://admins.mahaviharahlegu.org/uploads/gallery/${selectedImage.image_path}`}
                            alt="Gallery"
                            className="lightbox-image"
                        />
                        <button className="lightbox-close" onClick={closeLightbox}>
                            ×
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Gallery; 